import FormTextInputConfig from './components/form-text-input.config'
import FormWidgetSpaceConfig from './components/form-widget-space.config'
import FormDateSelectConfig from './components/form-date-select.config'
import FormTextareaInputConfig from './components/form-textarea-input.config'
import FormPhoneInputConfig from './components/form-phone-input.config'
import FormEmailInputConfig from './components/form-email-input.config'
import FormIdCardInputConfig from './components/form-id-card-input.config'
import FormNumberInputConfig from './components/form-number-input.config'
import FormMoneyInputConfig from './components/form-money-input.config'
import FormDocumentNumberConfig from './components/form-document-number.config'
import FromUploadConfig from './components/form-upload.config'
import FormValueSelectConfig from './components/form-value-select.config'
import FormRichTextConfig from './components/form-rich-text.config'
import FormValueRadioConfig from './components/form-value-radio.config'
import FormWidgetTableConfig from './components/form-widget-table.config'
import FormValueCheckboxConfig from './components/form-value-checkbox.config'
import FormPeopleSelectConfig from './components/form-people-select.config'
import FormDepartmentSelectConfig from './components/form-department-select.config'
import FormWidgetCalcConfig from './components/form-widget-calc.config'
import FormStaticTextConfig from './components/form-static-text.config'
import FormWidgetSplitConfig from './components/form-widget-split.config'
import FormStaticImgConfig from './components/form-static-img.config'
import FormAssiciatedConfig from './components/form-assiciated.config'
import FormWidgetLovConfig from './components/form-widget-lov.config'
import FormWidgetLovAssignmentConfig from './components/form-widget-lov-assignment.config'
import FormWidgetLocationConfig from './components/form-widget-location.config'
import FormWidgetAreaConfig from './components/form-widget-area.config'
import FormDataStatisticsConfig from './components/form-data-statistics.config'
import FormOrcInputConfig from './components/form-orc-input.config'
import FormOtherTableField from './components/form-other-table-field.config'
import FormHyperlinkInputConfig from './components/form-hyperlink-input.config'

export default {
  FormTextInputConfig,
  FormWidgetSpaceConfig,
  FormDateSelectConfig,
  FormTextareaInputConfig,
  FormPhoneInputConfig,
  FormEmailInputConfig,
  FormIdCardInputConfig,
  FormNumberInputConfig,
  FormMoneyInputConfig,
  FormDocumentNumberConfig,
  FromUploadConfig,
  FormValueSelectConfig,
  FormRichTextConfig,
  FormValueRadioConfig,
  FormWidgetTableConfig,
  FormValueCheckboxConfig,
  FormPeopleSelectConfig,
  FormDepartmentSelectConfig,
  FormWidgetCalcConfig,
  FormStaticTextConfig,
  FormWidgetSplitConfig,
  FormStaticImgConfig,
  FormWidgetLovConfig,
  FormWidgetLovAssignmentConfig,
  FormAssiciatedConfig,
  FormWidgetLocationConfig,
  FormWidgetAreaConfig,
  FormDataStatisticsConfig,
  FormOrcInputConfig,
  FormOtherTableField,
  FormHyperlinkInputConfig
}
